import React from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';

const OptionsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: right;
`;

const OptionsButton = styled.button`
    margin: 5px;
    border-radius: 6px;
    padding: 8px;
    border-color: #ff8560;
    background: transparent;
    text-align: center;
    font-size: 14px;
    :hover {
        background-color: lightgray;
    }
`;

const Options = (props) => {
    const options = [
        {
            text: 'Email',
            handler: props.actions.handleEmailOption,
            id: 1,
        },
        {
            text: 'Help',
            handler: props.actions.handleHelpOption,
            id: 2,
        },
        {
            text: 'How It Works',
            handler: props.actions.handleVideoOption,
            id: 3,
        },
        // { text: 'Fun Facts', handler: () => {}, id: 3 },
    ];

    const buttonsMarkup = options.map((option) => (
        <OptionsButton key={option.id} onClick={option.handler}>
            {option.text}
        </OptionsButton>
    ));

    return <OptionsContainer>{buttonsMarkup}</OptionsContainer>;
};

Options.propTypes = {
    actions: propTypes.shape({
        handleEmailOption: propTypes.func,
        handleHelpOption: propTypes.func,
        handleVideoOption: propTypes.func,
    }),
};

export default Options;
